// import { useEffect, useRef } from "react";

import { useEffect, useRef } from "react";

// export const useFetchDataRealtimeSync = ({
//       notifications,
//       getData,
//       path
// }: {
//       notifications: any;
//       getData: () => void;
//       path: string;
// }) =>
// {
//       const lastNotifIdRef = useRef<string | number | null>(null);
//       const refreshTimeoutRef = useRef<any>(null);

//       // debounce refresh
//       const triggerRefresh = () =>
//       {
//             if (refreshTimeoutRef.current)
//             {
//                   clearTimeout(refreshTimeoutRef.current);
//             }

//             refreshTimeoutRef.current = setTimeout(() =>
//             {
//                   getData();
//             }, 800); // debounce 0.8s
//       };

//       // socket / redux notification sync
//       useEffect(() =>
//       {
//             if (!notifications?.length) return;

//             const latestNotif = notifications[0];
//             if (!latestNotif) return;

//             // tránh duplicate event
//             if (lastNotifIdRef.current === latestNotif.id) return;
//             lastNotifIdRef.current = latestNotif.id;

//             const tags: string[] = latestNotif?.tags || [];

//             const isRelated = tags.some((tag) =>
//                   tag.includes(path)
//             );

//             console.log(isRelated, 'isRelated');

//             if (isRelated)
//             {
//                   triggerRefresh();
//             }
//       }, [notifications]);

//       //  fallback polling chống socket delay
//       useEffect(() =>
//       {


//             const interval = setInterval(() =>
//             {
//                   getData();
//             }, 60000); // 60s fallback sync

//             return () => clearInterval(interval);
//       }, []);

//       return null;
// };

/**
 * Robust tag extractor for notifications coming from different sources:
 *  - REST API: { tags: ["order/..."] } already parsed
 *  - Socket (after our parser): { tags: ["order/..."] } already parsed
 *  - Socket raw fallback: tags are still nested inside message which is either
 *    a JSON string or a Python-style dict using single quotes.
 */
const extractTags = (notif: any): string[] =>
{
      if (Array.isArray(notif?.tags) && notif.tags.length > 0) return notif.tags;

      const raw = notif?.message;
      if (typeof raw !== "string") return [];

      // Try strict JSON first (BE may send double-quoted JSON)
      let inner: any = raw;
      try
      {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === "object")
            {
                  if (Array.isArray(parsed.tags)) return parsed.tags;
                  if (typeof parsed.message === "string") inner = parsed.message;
            }
      } catch
      {
            // not JSON, keep raw
      }

      if (typeof inner !== "string") return [];

      // Try JSON one more time on the inner string
      try
      {
            const obj = JSON.parse(inner);
            if (obj && Array.isArray(obj.tags)) return obj.tags;
      } catch
      {
            // fall back to python-dict regex
      }

      // Python-style dict with single quotes: {'tags': ['order/...']}
      const match = inner.match(/'tags'\s*:\s*\[([^\]]*)\]/);
      if (!match) return [];

      return match[1]
            .split(",")
            .map((s) => s.trim().replace(/^['"]|['"]$/g, ""))
            .filter(Boolean);
};

export const useFetchDataRealtimeSync = ({
      notifications,
      getData,
      path,
}: {
      notifications: any;
      getData: () => void;
      path: string;
}) =>
{
      const lastNotifIdRef = useRef<string | number | null>(null);
      const refreshTimeoutRef = useRef<any>(null);
      const getDataRef = useRef(getData);


      useEffect(() =>
      {
            getDataRef.current = getData;
      }, [getData]);

      const triggerRefresh = () =>
      {
            if (refreshTimeoutRef.current)
            {
                  clearTimeout(refreshTimeoutRef.current);
            }

            refreshTimeoutRef.current = setTimeout(() =>
            {
                  getDataRef.current();
            }, 800);
      };

      useEffect(() =>
      {
            if (!notifications?.length) return;

            const latestNotif = notifications[0];
            if (!latestNotif) return;

            if (lastNotifIdRef.current === latestNotif.id) return;
            lastNotifIdRef.current = latestNotif.id;

            const tags: string[] = extractTags(latestNotif);

            const isRelated = tags.some((tag) => tag.includes(path));

            if (isRelated)
            {
                  triggerRefresh();
            }
      }, [notifications, path]);

      useEffect(() =>
      {
            const interval = setInterval(() =>
            {
                  getDataRef.current();
            }, 300000);

            return () => clearInterval(interval);
      }, []);

      return null;
};